define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi",
	"csi/_base/underscore",
	"csi/action/ImageWhereUsed",
	"csi/comm",
	"csi/def/Action",
	"csi/heading/RefImage",
	"csi/heading/RefImageView",
	"csi/heading/RefreshThumbnail",
	"csi/image/_base",
	"csi/model/image",
	"csi/reflection",
	"csi/xml"
], function(declare, lang, csi, _, ImageWhereUsed, comm, Action, RefImage, RefImageView, RefreshThumbnail, csiImage, {getImageData}, reflection, xml) {

	return declare(RefImage, {
		/** @property {boolean} globalContext - set to true to indicate images are being shown in global context (image browser) and can be edited */
		globalContext: false,

		toThumbnail: function(/*Context*/ctx, /*Heading*/h) {
			// summary: return href for viewable image
			return comm.getFileHref(ctx.getNode()[reflection.ATTR_THUMBNAIL]);
		},

		toViewable: function(/*Context*/ctx, /*Heading*/h) {
			// summary: return href for viewable image
			return comm.getFileHref(ctx.getNode()[reflection.ATTR_VIEWABLE]);
		},

		_getImageNode: function(/*Context*/ctx, /*Heading*/h) {
			// summary: return current node
			return ctx.getNode();
		},

		_getImageSrc: function(/*Context*/ctx, /*Heading*/h, /*String*/idImage) {
			// summary: return href for image
			var node = this._getImageNode(ctx, h);
			if (!node) {
				return null;
			}

			// use Heading id rather than that defined by the image size in the context
			idImage = h.m_id;

			// if the URL is empty it could be that the thumbnail is not generated yet.
			// Give the server a chance to generate it calling GetFromNode operation as specified in the base class
			var url = node[idImage];
			if ((url == csi.EMPTY_URL) && (idImage !== reflection.ATTR_VIEWABLE)) {
				return this.inherited(arguments, [ctx, h, idImage]);
			}

			return comm.getFileHref(url);
		},

		_getTooltipActions: function(/*Context*/ctx, /*Heading*/h, /*Boolean*/bBrowse) {
			// summary: return actions to refresh thumbnail and others based on context
			const node = ctx.getNode();
			const imageData = getImageData(node, null, null, null, null, null, this.globalContext);
			const a = [this._mixinTooltipAction(new RefreshThumbnail(), h, true)];

			if (ctx.bReserveClick) {
				// if selecting images, then use tooltip action to trigger lightbox
				a.unshift(this._mixinTooltipAction(new RefImageView(), h, true));
			}

			// allow tagging of images only if browsing of images is allowed
			if (bBrowse) {
				a.push(this._getTagAction(ctx, h));
			}

			if (imageData.editableImage) {
				const popupAction = lang.mixin(new Action(), {
					m_id: "ImageEditImage",
					classController: "csi/image/ImageEditorController",
					classControllerParams: {
						imageData,
					},
					m_postAction: () => {
						ctx.view.redrawImages([imageData.url]);
					}
				});

				popupAction.resolve();
				a.unshift(popupAction);
			}

			if (imageData.showWhereUsed) {
				a.push(this._mixinTooltipAction(new ImageWhereUsed().init(node.$URL), h));
			}

			return a;
		},

		_onImageLoad: function(/*Context*/ctx, /*Heading*/h, /*DOMNode*/img) {
			// summary: extension point for processing image once loaded - be careful because context may
			// have changed by this point, so node in context is passed explicitly
			if (ctx.bReserveClick) {
				// if view is drop source, then add src for viewable image to image -
				// let tooltip house action to show lightbox rather than img onclick
				var viewable = csiImage.getImageSrc(ctx.getNode(), null, reflection.ATTR_VIEWABLE);
				if (viewable && (img.getAttribute("src") != viewable)) {
					var ext = xml.nodeGetName(ctx.getNode()).toLowerCase().split(".")[1];
					img.setAttribute("srcDrop", viewable);
					img.setAttribute("srcExt", ext);
				}
			} else {
				// add onclick for image
				this.inherited(arguments);
			}
		}
	});
});
